var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendBg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.687 10.3289C29.5391 10.1798 29.3521 10.0757 29.1476 10.0285C28.943 9.98126 28.7292 9.99295 28.531 10.0622L28.2287 10.1689L10.7474 16.2865C10.5383 16.3626 10.3561 16.4983 10.2234 16.6769C10.0906 16.8555 10.0131 17.0691 10.0005 17.2912C9.99385 17.5139 10.0537 17.7335 10.1725 17.922C10.2913 18.1105 10.4636 18.2593 10.6674 18.3494L17.2029 21.257L18.2788 21.7371L18.7856 22.8753L21.6576 29.3485C21.7488 29.5513 21.8987 29.7221 22.088 29.8388C22.2772 29.9555 22.4971 30.0128 22.7193 30.0032C22.9414 29.9936 23.1555 29.9176 23.334 29.7851C23.5125 29.6525 23.6472 29.4695 23.7206 29.2596L29.9448 11.476C29.949 11.4585 29.949 11.4402 29.9448 11.4226C30.0078 11.2344 30.0171 11.0323 29.9715 10.8391C29.926 10.6459 29.8274 10.4692 29.687 10.3289Z",
    fill: "#888DA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendBg);
export default __webpack_public_path__ + "static/media/send-bg.c51899d2b556e988601d854e72f2d1c3.svg";
export { ForwardRef as ReactComponent };